<template>
  <div class="sidebar">
    <div class="sidebar__nav main-nav">


      <router-link v-for="item in menu" :key="item.route"
                   @click="hideSidebar"
                   class="main-nav__item"
                   :class="{'main-nav__item--selected': item.route === route.name}"
                   :active-class="''"
                   :exact-active-class="''"
                   :to="{name: item.route, query: item.query}"
      >

        <div class="main-nav__icon">
          <img :src="require(`@/apps/public/assets/img/menu/${item.route}.svg`)">
        </div>
        <span class="text-capitalize-first">{{ $t(`menu.items.${item.route}`) }}</span>
      </router-link>
      <a href="#" @click.prevent="doLogout()" class="main-nav__item hide-sm">
        <div class="main-nav__icon"><img :src="require(`@/apps/public/assets/img/menu/logout.svg`)"></div>
        <span class="text-capitalize-first">{{$t('labels.logout')}}</span></a>
    </div>

    <div class="sidebar__links" v-if="isTrader || isTraderOperator">
      <div v-if="usdtRate" class="sidebar__link">
        <div class="sidebar__link-title">
          {{ $t('labels.rateUsdt') }}
        </div>
        <div class="sidebar__link-content">
          <div class="sidebar__link-image">
            <img :src="require('@/apps/public/assets/img/usdt.svg')">
          </div>
          {{ usdtRate ? numberFormatter.formatMoney(usdtRate) : '' }}
        </div>
      </div>
      <router-link :to="{name:'settings'}" class="sidebar__link" v-if="isTrader">
        <div class="sidebar__link-title">
          {{ $t('labels.telegram_bot_notifications') }}
        </div>
        <div class="sidebar__link-content">
          <div class="sidebar__link-image">
            <img :src="require('@/apps/public/assets/img/tg.svg')">
          </div>
          <span v-if="telegramMe?.username">
            {{ $t('labels.connectTo') }} <strong>@{{telegramMe.username}}</strong>
          </span>
          <span v-else>
            {{ $t('labels.connect') }}
          </span>

        </div>
      </router-link>
      <a :href="manualLink" target="_blank" class="sidebar__link" v-if="manualLink">
        <div class="sidebar__link-title">
          {{ $t('labels.howToGuide') }}
        </div>
        <div class="sidebar__link-content">
          <div class="sidebar__link-image">
            <img :src="require('@/apps/public/assets/img/instruction.svg')">
          </div>
          {{ $t('labels.instruction') }}
        </div>
      </a>
      <a :href="bankAppsLink" target="_blank" class="sidebar__link" v-if="bankAppsLink">
        <div class="sidebar__link-title">
          {{ $t('labels.bankMobileApp') }}
        </div>
        <div class="sidebar__link-content">
          <div class="sidebar__link-image">
            <img :src="require('@/apps/public/assets/img/app.svg')">
          </div>
          {{ $t('labels.downloadApk') }}
        </div>
      </a>
    </div>
  </div>

</template>
<script lang="ts">
import {defineComponent, toRefs, reactive, computed, onMounted, onUnmounted} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import TelegramMeDTO from "@/models/TelegramMeDTO";
import {api} from "@/service/APIClient";
import MoneyDTO from "@/models/MoneyDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import router from "@/apps/public/router";

export default defineComponent({
  name: 'Sidebar',
  methods: {$t},
  components: {
  },
  setup() {
    const store = useStore()
    const route = useRoute()

    const state = reactive({
      telegramMe: null as TelegramMeDTO|null,
      updateRateInterval: null as any,
      usdtRate: null as MoneyDTO|null,
      bankAppsLink: '' as string,
      manualLink: '' as string,
    });

    const getTelegramMe = async () => {
      try {
        state.telegramMe = await api.getTgMe();
      } finally {
      }
    }

    const menu = computed(() => {
      if (store.getters.isTraderOperator) {
        return [
          { route: 'dashboard'},
          { route: 'deals'},
          { route: 'disputes'},
          { route: 'statistic'},
          { route: 'requisites'},
          { route: 'settings'},
        ]
      }

      if (store.getters.isTrader) {
        if (store.getters.getUser.pcId) {
          return [
            { route: 'dashboard'},
            { route: 'deals'},
            { route: 'disputes'},
            { route: 'statistic'},
            { route: 'settings'},
          ]
        }

        return [
          { route: 'dashboard'},
          { route: 'deals'},
          { route: 'disputes'},
          { route: 'statistic'},
          { route: 'requisites'},
          { route: 'traderOperators'},
          { route: 'settings'},
        ]
      }

      if (store.getters.isMerchant) {
        return [
          { route: 'dashboard' },
          { route: 'statistic'},
          { route: 'settings'},
        ]
      }
      return []
    })

    const updateRates = async () => {
      const rates =  await api.currencyRates();
      state.usdtRate = rates.length > 0 ? (rates[0].rate as unknown as MoneyDTO) : null;
    }

    const hideSidebar = () => {
      document.documentElement.setAttribute('data-sidebar', 'hidden')
    }

    onMounted(() => {
      if (store.getters.isTrader || store.getters.isTraderOperator) {
        getTelegramMe()
        updateRates();
        state.updateRateInterval = setInterval(updateRates, 15000)

        api.manualLink().then(resp => state.manualLink = resp);
        api.bankAppsLink().then(resp => state.bankAppsLink = resp);
      }
    })

    const doLogout = () => {
      store.dispatch('logout');
      router.push('login');
    }

    onUnmounted(() => {
      if (state.updateRateInterval) {
        clearInterval(state.updateRateInterval)
        state.updateRateInterval = null
      }
    })

    return {
      ...toRefs(state),
      doLogout,
      hideSidebar,
      store,
      menu,
      helper,
      route,
      numberFormatter,
      isTrader: computed(() => store.getters.isTrader),
      isTraderOperator: computed(() => store.getters.isTraderOperator),
    }
  }
})
</script>
